import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Folder, Layers, ScrollText, CalendarDays, RotateCw, History, BarChart3, FileCheck2, Gift, Menu, X } from "lucide-react";
import Logo from "./Logo";
import { cn } from "../lib/utils";

const NAV = [
  { to: "/dashboard", label: "Home", icon: Home },
  { to: "/planos", label: "Planos", icon: Folder },
  { to: "/disciplinas", label: "Disciplinas", icon: Layers },
  { to: "/edital", label: "Edital", icon: ScrollText },
  { to: "/planejamento", label: "Planejamento", icon: CalendarDays },
  { to: "/revisoes", label: "Revisões", icon: RotateCw },
  { to: "/historico", label: "Histórico", icon: History },
  { to: "/estatisticas", label: "Estatísticas", icon: BarChart3 },
  { to: "/simulados", label: "Simulados", icon: FileCheck2 },
  { to: "/convide", label: "Convide e Ganhe", icon: Gift },
];

export default function Sidebar({ open, onClose }) {
  const location = useLocation();
  return (
    <>
      {/* Mobile overlay */}
      {open && (
        <div className="fixed inset-0 z-40 bg-black/40 md:hidden" onClick={onClose} />
      )}
      <aside
        className={cn(
          "fixed md:sticky top-0 left-0 z-50 h-screen w-64 bg-tiffany-500 text-white flex flex-col transition-transform duration-200",
          open ? "translate-x-0" : "-translate-x-full md:translate-x-0"
        )}
      >
        <div className="px-5 pt-5 pb-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="bg-white/15 rounded-lg p-1.5">
              <span className="font-display font-extrabold text-xl tracking-tight">estudei</span>
            </div>
          </div>
          <button className="md:hidden text-white/80 hover:text-white" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <nav className="flex-1 px-3 space-y-1 overflow-y-auto pb-4">
          {NAV.map((item) => {
            const Icon = item.icon;
            const active = location.pathname === item.to;
            return (
              <Link
                key={item.to}
                to={item.to}
                onClick={onClose}
                className={cn(
                  "flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-semibold transition-colors",
                  active
                    ? "bg-white text-tiffany-600 shadow-sm"
                    : "text-white/95 hover:bg-white/10"
                )}
              >
                <Icon size={18} />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="px-5 py-4 text-xs text-white/70 border-t border-white/10">
          © {new Date().getFullYear()} estudei
        </div>
      </aside>
    </>
  );
}

export function SidebarToggle({ onClick }) {
  return (
    <button className="md:hidden p-2 rounded-md hover:bg-muted" onClick={onClick}>
      <Menu size={20} />
    </button>
  );
}
